import eventBus from '@tools/event-bus';
import { URL_USER_INBOX } from '@tools/routes/routes';

export default function () {
  function initUserLoginClick() {
    const elements = document.querySelectorAll('.header__buttons a, a.header__buttons');
    if (elements) {
      elements.forEach((element) => {
        element.addEventListener('click', () => {
          eventBus.dispatchEvent(new Event('show-login-modal'));
        });
        element.setAttribute('data-ready', true);
      });
    }
  }

  function openUserMenu() {
    document.getElementById('user-menu--mobile').classList.add('mobile-menu-opened');
  }

  function closeUserMenu(evt) {
    if (evt.target.classList.contains('menu-mobile-wrapper')
      || evt.target.classList.contains('menu-mobile-panel__top-close')) {
      document.getElementById('user-menu--mobile').classList.remove('mobile-menu-opened');
    }
  }

  function goHome() {
    window.location.href = URL_USER_INBOX;
  }

  /**
   * initUserMenu
   * @description Add on click() event onto burger menu, in order to display menu on mobile only.
   */
  function initUserMenu() {
    const burger = document.querySelector('.header .header__burger');
    if (!burger) {
      return;
    }
    const logo = document.querySelector('.header .header__mobile-notifications--logo');
    const menu = document.getElementById('user-menu--mobile');
    if (window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet || window.BREAKPOINTS.isTabletLarge) {
      burger.removeEventListener('click', openUserMenu, false);
      burger.addEventListener('click', openUserMenu, false);
      logo?.addEventListener('click', goHome, false);
      menu.addEventListener('click', closeUserMenu, false);
    } else {
      burger.removeEventListener('click', openUserMenu, false);
      menu.classList.remove('mobile-menu-opened');
    }

    initUserLoginClick();

    const modalClosingListener = () => {
      menu.classList.remove('mobile-menu-opened');
    };

    eventBus.addEventListener('modal-is-closing', modalClosingListener);
  }

  // Init menu behaviour, then Add resize event in order to allow window resize
  initUserMenu();
  window.onresize = initUserMenu;
}
